import useCheckFreeTrialEnrollmentEligible from './useCheckFreeTrialEnrollmentEligible';

export default useCheckFreeTrialEnrollmentEligible;
